import { ProductType } from '../../../common';
import { FromPrice, SFCCFamilyPrice, SFCCPricingSearchResult } from '../../models';
import { getPricesByIds } from './get-prices-by-ids';

/**
 * Fetch the price for a given family ID.
 * @param familyId - The ID of the family for which to fetch the price.
 * @returns The fetched price as `FromPrice` or `SFCCFamilyPrice`, or `null` if no price is found.
 */
export const getFamilyPrice = async (
  familyId: number
): Promise<FromPrice | SFCCFamilyPrice | null> => {
  const prices = await getPricesByIds<FromPrice[] | SFCCPricingSearchResult>(
    [familyId],
    ProductType.Family
  );

  if (!prices) {
    console.warn(`No prices found for familyId: ${familyId}`);
    return null;
  }

  const fromPrice = (prices as FromPrice[])?.[0];
  const sfccPrice = (prices as SFCCPricingSearchResult)?.search_phrase_suggestions?.c_prices?.[0];

  return fromPrice || sfccPrice || null;
};
